module.exports = __webpack_public_path__ + "media/field_goal_left.f5071bcb.mp4";